export enum dictionariesUrls {
    ferries = "dictionaries/ferries",
    ports = "dictionaries/ports",
    companies = "dictionaries/companies",
    shipowners = "dictionaries/shipowners",
    unCodes = "dictionaries/un-codes",
    ownedVehicles = "dictionaries/owned-vehicles",
    countries = "dictionaries/countries",
    packing = "dictionaries/packing"
}